module.exports = __webpack_public_path__ + "static/media/2019-Mustang-Coupe-V8.8d3d0653.jpg";